import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";

export default function FAQ() {
  const { t } = useLanguage();
  const tx = translations.faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-[#F5F0E8] py-24 lg:py-36">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
        {/* Heading */}
        <div className="text-center mb-14 lg:mb-20">
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-[1px] w-10 bg-[#9C8456]" />
            <span
              className="text-[#9C8456] text-[11px] tracking-[0.45em] uppercase"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.eyebrow)}
            </span>
            <div className="h-[1px] w-10 bg-[#9C8456]" />
          </div>
          <h2
            className="text-[#2A2A28] text-[34px] sm:text-[48px] lg:text-[58px] leading-[1.08] max-w-3xl mx-auto"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
          >
            {t(tx.title1)} <em className="italic">{t(tx.title2)}</em>
          </h2>
          <p
            className="text-[#3a3a36] text-[15px] lg:text-[17px] leading-[1.85] mt-7 max-w-2xl mx-auto"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
          >
            {t(tx.intro)}
          </p>
        </div>

        {/* Accordion */}
        <div className="divide-y divide-[#D4CBB8]/60 border-y border-[#D4CBB8]/60">
          {tx.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="py-2">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left py-5 lg:py-6 flex items-start justify-between gap-6 group"
                >
                  <div className="flex items-start gap-5 flex-1">
                    <span
                      className="text-[#9C8456] text-[12px] tracking-[0.3em] mt-1 flex-shrink-0"
                      style={{ fontFamily: "'Jost', sans-serif", fontWeight: 500 }}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3
                      className={`text-[20px] lg:text-[26px] leading-[1.3] transition-colors duration-300 ${
                        isOpen ? "text-[#9C8456]" : "text-[#2A2A28] group-hover:text-[#9C8456]"
                      }`}
                      style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
                    >
                      {t(item.q)}
                    </h3>
                  </div>
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-full border flex items-center justify-center transition-all duration-300 ${
                      isOpen
                        ? "bg-[#9C8456] border-[#9C8456] text-white rotate-180"
                        : "border-[#9C8456]/40 text-[#9C8456] group-hover:border-[#9C8456]"
                    }`}
                  >
                    {isOpen ? (
                      <Minus className="w-4 h-4" strokeWidth={1.5} />
                    ) : (
                      <Plus className="w-4 h-4" strokeWidth={1.5} />
                    )}
                  </div>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="pl-12 pr-12 lg:pl-[58px] pb-7">
                      <p
                        className="text-[#3a3a36] text-[15px] lg:text-[16px] leading-[1.85]"
                        style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                      >
                        {t(item.a)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <p
            className="text-[#6B6760] text-[15px] mb-5"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontStyle: "italic" }}
          >
            {t(tx.cta)}
          </p>
          <a
            href="#contacto"
            className="inline-flex items-center justify-center px-10 py-4 text-[11px] tracking-[0.3em] uppercase border border-[#2A2A28] text-[#2A2A28] hover:bg-[#2A2A28] hover:text-[#F5F0E8] transition-colors duration-300"
            style={{ fontFamily: "'Jost', sans-serif" }}
          >
            {t(tx.ctaButton)}
          </a>
        </div>
      </div>
    </section>
  );
}
